import { LoggedInHeader } from '@common/components/LoggedInHeader';
import { LoggedOutHeader } from '@common/components/LoggedOutHeader';
import { LoaderCircular } from '@common/components/LoaderCircular';
import { Conditional } from '@consumidor-positivo/aurora';
import { HubModal } from '@hub/components/HubModal';
import { Footer } from '@common/components/Footer';

import { useUserContext } from '@common/contexts/UserContext';
import { Suspense, PropsWithChildren } from 'react';
import { StorageMap } from '@common/constants/StorageMap';

import { AppNavigation } from '@common/Templates/HomeDefault/components/AppNavigation';

import 'iq-blueberry/src/core/components/legacy/FooterClassic.styl';
import { Outlet } from 'react-router-dom';

type HomeDefaultTemplateProps = PropsWithChildren<{
  useOutlet?: boolean;
  showHubModal?: boolean;
}>;

export const HomeDefaultTemplate = ({ children, useOutlet = true, showHubModal = true }: HomeDefaultTemplateProps) => {
  const { user } = useUserContext();

  const promotionViewed = localStorage.getItem(StorageMap.ScorePromotion) === 'true';

  return (
    <>
      <Conditional condition={!!user} renderIf={<LoggedInHeader username={user?.full_name} />} renderElse={<LoggedOutHeader />} />
      <main className="private-default-template">
        <Suspense fallback={<LoaderCircular fullPage />}>
          <Conditional condition={useOutlet} renderIf={<Outlet />} renderElse={children} />
        </Suspense>

        <AppNavigation hasNotifier={!promotionViewed} hasNotifierLabel="Score" />
      </main>

      <Conditional condition={showHubModal} renderIf={<HubModal />} />
      <Footer />
    </>
  );
};
